import React, { FC, use, useMemo } from "react";
import { GenericRecord } from "../../../scripts/models";
import { clsx } from "clsx";
import { TableGetters } from "./TableGetters";
import type { GenericRecordTableItem } from "@app/components/shared/Table/Table";
import { type AllRecordsData, RecordsContext } from "../../../scripts/context/accountingData/RecordsCtx";
import { PaymentsContext } from "../../../scripts/context/accountingData/PaymentsProvider";

const getRecordSaldoOrigin = (r: GenericRecord, allRecords: AllRecordsData["map"]) => {
    if (!r) {
        return null;
    }
    return r.saldoSourceId ? allRecords.get(r.saldoSourceId) : r;
};

export const useRecordSaldoOrigin = (r: GenericRecord) => {
    const { allRecords } = use(RecordsContext);
    return useMemo(() => {
        return getRecordSaldoOrigin(r, allRecords.map);
    }, [allRecords.map, r]);
};

type Props = {
    tableItem: GenericRecordTableItem;
    onClick?: (record: GenericRecord) => void;
};
export const ColStatus: FC<Props> = ({ tableItem, onClick }) => {
    const { recordRelation } = use(PaymentsContext);
    // if there is a pointer to the saldo record, we should edit payments there
    const paymentRecord = useRecordSaldoOrigin(tableItem?.item);
    if (!paymentRecord) {
        return "";
    }

    const o = TableGetters.computedStatus({ ...tableItem, item: paymentRecord }, recordRelation.get(paymentRecord.key));

    return !o ? (
        ""
    ) : (
        <p
            onClick={() => onClick(paymentRecord)}
            className={clsx("status", "status-clickable", {
                "status-offenColor": o.abbr === "offen",
                "status-bezahltColor": o.abbr === "bezahlt",
                "status-avisColor": o.abbr === "AVIS",
            })}
        >
            {o.abbr}
        </p>
    );
};
